import React from 'react';
import { Modal, Select, Button, Upload, Icon, notification, message  } from 'antd';
import infoBlue from '../../images/info-blue.png';
import infoPink from '../../images/info-pink.png';
import infoGray from '../../images/info-gray.png';
const Option = Select.Option;


class AddLog extends React.Component {

  state = {
    title: "",
    clss: '',
    category: '',
    cluster: '',
    skillCluster: '',
    skill: '',
    notes: "",
    skillHelp: false,
    attachments: null,
    toDelete: []
  }

  componentDidUpdate(prevProps) {
    if (this.props.open && this.props.editingLog && this.props.open !== prevProps.open) {
      const log = this.props.editingLog
      console.log('logasd', log);
      let attachments = []
      log.attachments && log.attachments.map((file, i) => {
        const attachment = {
          status: 'done',
          url: file.path,
          name: file.name,
          uid: i,
          storagePath: file.storagePath
        }
        attachments.push(attachment)
      })
      this.setState({
        title: log.title,
        clss: log.classId,
        category: log.categoryId,
        cluster: log.cluster,
        skill: log.skill,
        skillCluster: log.skillCluster,
        notes: log.notes,
        attachments
      })
    }
  }

  saveData = () => {

    let subjectId = this.props.classes && this.props.classes.filter( clss =>
      clss[0] == this.state.clss
    )[0][1]

    if (subjectId.subject) {
      subjectId = subjectId.subject
    } else {
      subjectId = null
    }

    let subject = this.props.subjects && this.props.subjects.filter( subj => subj[0] === subjectId)

    let categoryName = this.props.category && Object.entries(this.props.category).filter( category =>
      category[0] == this.state.category
    )
    categoryName = categoryName[0][1].name

    let skillId = this.props.skill && Object.entries(this.props.skill).filter( skill =>
      skill[1].name == this.state.skill
    )
    skillId = skillId[0][0]

    let clusterId = this.props.cluster && Object.entries(this.props.cluster).filter( cluster =>
      cluster[1].name == this.state.cluster
    )
    clusterId = clusterId[0][0]


    let data = {
      category: {
        id: this.state.category,
        name: categoryName
      },
      skill: {
        id: skillId,
        name: this.state.skill
      },
      cluster: {
        id: clusterId,
        name: this.state.cluster
      },
      subject: {
        id: subject[0][0],
        name: subject[0][1].name
      },
      skillCluster: this.state.skillCluster,
      notes: this.state.notes,
      title: this.state.title,
      user_id: this.props.uid,
      classId: this.state.clss
    }
    this.setState({
      title: "",
      clss: '',
      category: '',
      cluster: '',
      skullCluster: '',
      skill: '',
      notes: ""
    })

    this.props.addLog(data, this.state.toDelete)
    this.setState({toDelete: []})

  }

  prepareUpload = (props) => {
    if (this.props.editingLog) { //Filelist is controlled if in edit mode
      let { attachments } = this.state
      let attachment = {
        status: 'done',
        name: props.file.name,
        uid: props.file.uid
      }
      attachments.push(attachment)
      this.setState({attachments})
    }
    this.props.prepareUpload(props)
  }

  checkSubmit = () => {
    const { t } = this.props;

    if (
      !this.props.editingLog &&
      (this.state.title == "" ||
      this.state.clss == '' ||
      this.state.skillCluster == '' ||
      this.state.category == '' ||
      this.state.cluster == '' ||
      this.state.skill == '' ||
      this.props.upload.length == 0 ||
      this.state.notes == "")
    ) {
      message.error(t('All fields are mandatory'));
    } else if (
      this.props.editingLog &&
      (this.state.title == "" ||
      this.state.clss == '' ||
      this.state.category == '' ||
      this.state.cluster == '' ||
      this.state.skillCluster == '' ||
      this.state.skill == '' ||
      this.state.notes == "")
    ) {
      message.error(t('All fields are mandatory'));
    } else {
      this.saveData()
    }
  }

  openSkillHelp = () => {
    if (!this.state.skillHelp) {
      let colorClass;
      const { color } = this.props
      if (color == '#F190AC') {
        colorClass = 'pink'
      } else if (color == '#7c868d') {
        colorClass = 'gray'
      } else {
        colorClass = 'blue'
      }

      notification.config({
        placement: 'topLeft',
        duration: 0
      });
      notification.open({
        className: colorClass,
        message: 'Skill level description',
        onClose: () => this.setState({skillHelp: false}),
        description: <td dangerouslySetInnerHTML={{__html: this.props.skill_description}} />,
      });
      this.setState({skillHelp: true})
    }
  }

  deleteFile = (file) => {
    let { toDelete, attachments } = this.state
    attachments = attachments.filter( item =>
      item.name !== file.name
    )
    toDelete.push({name: file.name, storagePath: file.storagePath})
    this.setState({toDelete, attachments})
  }

  getSkillClusters = () => {
    let list = []
    let clusterId = this.props.cluster && Object.entries(this.props.cluster).filter(cluster => cluster[1].name === this.state.cluster && !cluster[1].readOnly)[0]
    let skillClusters = Object.entries(this.props.skillClusters)
    if (clusterId) {
      clusterId = clusterId[0]
      list = skillClusters.filter(skill => skill[1].cluster === clusterId)
    }
    return list
  }

  render() {

    const { color, t } = this.props

    let infoIcon;
    if (color == '#7c868d') {
      infoIcon = infoGray
    } else if (color == '#F190AC') {
      infoIcon = infoPink
    } else {
      infoIcon = infoBlue
    }

    let categories;
    if (this.props.category) { categories = Object.entries(this.props.category) }

    let clusters;
    if (this.props.cluster) {
      clusters = Object.entries(this.props.cluster)
      if (this.state.category !== '') {
        clusters = clusters.filter( cluster =>
          cluster[1].category == this.state.category
          // ||
          // cluster[1].category ==
        )
      }
    }

    let skills;
    if (this.props.skill) { skills = Object.entries(this.props.skill) }

    const styles = {
      title: {
        color: color,
        fontSize: 16,
        fontFamily: 'Arial Rounded MT Bold',
        marginLeft: 15,
        marginTop: 20,
      },
      input: {
        width: '100%',
        border: `1px solid ${color}`,
        height: 32,
        borderRadius: 20,
        paddingLeft: 10,
        fontSize: 17,
        height: 45
      },
      textarea: {
        height: 120,
        width: '100%',
        border: `1px solid ${color}`,
        borderRadius: 20,
        paddingLeft: 10,
        fontSize: 17
      },
      button: {
        backgroundColor: color,
        color: 'white',
        border: 'none',
        borderRadius: '20px',
        marginTop: 20
      },
      skillhelp: {
        width: 25,
        height: 25,
        position: 'relative',
        bottom: 3,
        cursor: 'pointer',
        marginLeft: 10
      }
    }

    return (
      <Modal
        visible={this.props.open}
        onCancel={this.props.close}
        footer={null}
        wrapClassName='addLog'
        width={750}
      >
        <h3 className='logTitle' style={styles.title}>{t('Class')}</h3>
        <Select value={this.state.clss} dropdownClassName='dropDown' style={{ width: '100%', border: `1px solid ${color}`, borderRadius: 20, margin: 1 }} onChange={(value) => this.setState({clss: value})}>
          {this.props.classes && this.props.classes.map( clss => (
            <Option value={clss[0]}>{clss[1].name}</Option>
          ))}
        </Select>
        <h3 className='logTitle' style={styles.title}>{t('Title of Work')}</h3>
        <input style={styles.input} placeholder={t("Insert your work title here")} onChange={(e) => this.setState({title: e.target.value})} value={this.state.title}/>
        <h3 className='logTitle' style={styles.title}>{t('Skill Category')}</h3>
        <Select value={this.state.category} dropdownClassName='dropDown' style={{ width: '100%', border: `1px solid ${color}`, borderRadius: 20, margin: 1 }} onChange={(value) => this.setState({category: value, cluster: ''})}>
          {categories && categories.map( category => (
            <Option disabled={category[1].readOnly} value={category[0]}>{t(category[1].name)}</Option>
          ))}
        </Select>
        <h3 className='logTitle' style={styles.title}>{t('Skill Cluster')}</h3>
        <Select value={this.state.cluster} dropdownClassName='dropDown' disabled={this.state.category == ''} style={{ width: '100%', border: `1px solid ${color}`, borderRadius: 20, margin: 1 }} onChange={(value) => this.setState({cluster: value, skillCluster: ''})}>
          {clusters && clusters.map( cluster => (
            <Option disabled={cluster[1].readOnly} value={cluster[1].name}>{t(cluster[1].name)}</Option>
          ))}
        </Select>
        <h3 className='logTitle' style={styles.title}>{t('Skill Description')}</h3>
        <Select value={this.state.skillCluster} dropdownClassName='dropDown wide' disabled={this.state.cluster == ''} style={{ width: '100%', border: `1px solid ${color}`, borderRadius: 20, margin: 1 }} onChange={(value) => this.setState({ skillCluster: value })}>
          {this.getSkillClusters().map(skill => (
            <Option value={skill[0]}>{skill[1].name}</Option>
          ))}
        </Select>
        <div style={{display: 'flex', alignItems: 'baseline'}}>
          <h3 className='logTitle' style={styles.title}>{t('Level of Skill')}</h3>
          {this.props.skill_description && <div onClick={() => this.openSkillHelp()} style={styles.skillhelp}><img style={{width: '80%', height: 'auto'}} src={infoIcon} /></div> }
        </div>
        <Select value={this.state.skill} dropdownClassName='dropDown' disabled={this.state.cluster == ''} style={{ width: '100%', border: `1px solid ${color}`, borderRadius: 20, margin: 1 }} onChange={(value) => this.setState({skill: value})}>
          {skills && skills.map( skill => (
            <Option value={skill[1].name}>{t(skill[1].name)}</Option>
          ))}
        </Select>
        <h3 className='logTitle' style={styles.title}>{t('Add notes')}</h3>
        <textarea style={styles.textarea} placeholder={t("Insert notes here")} onChange={(e) => this.setState({notes: e.target.value})} value={this.state.notes}/>
        {(this.props.open && this.props.editingLog) &&  /* This is just to reset uploadlist */
        <Upload
          fileList={this.state.attachments}
          disabled={this.props.upload.length == 5}
          customRequest={this.prepareUpload}
          onRemove={this.props.editingLog ? (file) => this.deleteFile(file) : (file) => this.props.removeFile(file)}
        >
          <Button style={styles.button}>
            <Icon type="upload" /> {t('Upload attachments')}
          </Button>
        </Upload>
        }
        {(this.props.open && !this.props.editingLog) &&  /* This is just to reset uploadlist */
        <Upload
          disabled={this.props.upload.length == 5}
          customRequest={this.prepareUpload}
          onRemove={this.props.editingLog ? (file) => this.deleteFile(file) : (file) => this.props.removeFile(file)}
        >
          <Button style={styles.button}>
            <Icon type="upload" /> {t('Upload attachments')}
          </Button>
        </Upload>
        }
        <p style={{margin: '10px 0px 0px 5px', fontSize: 12 }}>{t('Maximum 5 attachments')}</p>
        <Button style={styles.button} onClick={() => this.checkSubmit()}>
          <Icon type="save" /> {this.props.editingLog ? t('Update') : t('Submit')}
        </Button>
      </Modal>
    )
  }
}

export default AddLog;



// WEBPACK FOOTER //
// ./src/components/AddLog/index.jsx